import { isAxiosError } from "axios";

// API validation errors may be a field-to-messages map or a message array.
export const getApiErrorMessage = (error: unknown, fallback: string): string => {
  const body: unknown = isAxiosError(error) ? error.response?.data : error;
  if (body && typeof body === "object") {
    const response = body as { errors?: unknown; message?: unknown };
    const messages: string[] = [];
    const collect = (value: unknown): void => {
      if (typeof value === "string" && value.trim()) messages.push(value.trim());
      else if (Array.isArray(value)) value.forEach(collect);
      else if (value && typeof value === "object") Object.values(value).forEach(collect);
    };
    collect(response.errors);
    if (messages.length) return [...new Set(messages)].join("\n");
    if (typeof response.message === "string" && response.message.trim()) return response.message;
  }
  return error instanceof Error && error.message ? error.message : fallback;
};
